(function () {
  'use strict';

  /* Sticky header */

  var lastScrollTop = 0;
  // element should be replaced with the actual target element on which you have applied scroll, use window in case of no target element.
  window.addEventListener('scroll', function () {
    // or window.addEventListener("scroll"....
    const headerContainer = document.querySelector('.header__inner');
    const headerBar = this.document.querySelector('.header__bar');
    var st = window.scrollY || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
    if (st > lastScrollTop) {
      if (window.scrollY > 200) {
        headerContainer.classList.add('translate-100');
        if (headerBar) {
          headerBar.classList.add('translate-500');
        }
      }
    } else {
      headerContainer.classList.remove('translate-100');
      if (headerBar) {
        headerBar.classList.remove('translate-500');
      }
    }
    lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
  }, false);

})();
